import { render, staticRenderFns } from "./promotionListDlg.vue?vue&type=template&id=1488cad8"
import script from "./promotionListDlg.vue?vue&type=script&lang=js"
export * from "./promotionListDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports